import * as Sentry from '@sentry/react';
import type { FormikValues } from 'formik';
import { withFormik } from 'formik';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose } from 'recompact';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { createLeadAction, segmentAnalyticsEvent } from 'src/app/state/actions';
import type { Dispatch, RootState } from 'src/app/state/store';

import { Status } from './constants';
import validation from './validation';

import { Renderer } from '.';

const mapStateToProps = () => {
  return (state: RootState) => {
    const location = state?.router?.location;
    const { zipCode } = state.onboardingForm;

    return {
      location,
      zipCode,
    };
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchCreateLeadAction: attributes => {
    return dispatch(createLeadAction(attributes));
  },
  dispatchSegmentTrack: (event: UnifiedEvent, payload: object = {}) =>
    dispatch(segmentAnalyticsEvent(event.name, payload)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

const enhanceWithFormik = withFormik<PropsFromRedux, FormikValues>({
  mapPropsToValues: () => validation.initialValues,
  mapPropsToStatus: () => Status.DEFAULT,
  validationSchema: validation.schema,
  validateOnChange: true,
  validateOnBlur: false,
  handleSubmit: async (values, { props, setStatus, setSubmitting }) => {
    const { dispatchCreateLeadAction, dispatchSegmentTrack, location } = props;
    const attributes = {
      zipCode: values.zipCode,
      source: 'delivery_area_eligibility_form',
      email: values.waitlistEmail,
    };

    setSubmitting(true);
    try {
      await dispatchCreateLeadAction(attributes);
      dispatchSegmentTrack(UNIFIED.joinDeliveryAreaWaitlist, { pagepath: location?.pathname });
      setStatus(Status.SUCCESS);
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      setSubmitting(false);
    }
  },
});

export default compose(connector, withRouter, enhanceWithFormik)(Renderer);
